import { Trans } from "@lingui/react/macro";
import { useState } from "react";

import { QuestionnaireTypes } from "../../api";
import { ApiConnector } from "../../api/api-connector";
import { Button } from "../../components/ui-kit/button";
import { Select } from "../../components/ui-kit/fields/select";
import { questionnaireTypes } from "../../constants/enum-to-text";
import {
  QuestionnaireStats,
  statsStrategies,
  StatsStrategy,
} from "./questionnaire-stats";

export function QuestionnairesRoute(props: { api: ApiConnector }) {
  const [type, setType] = useState(QuestionnaireTypes.eq_5d_5l);
  const [strategy, setStrategy] = useState(StatsStrategy.last);
  const [showStatsFor, setShowStatsFor] = useState<{
    type: QuestionnaireTypes;
    strategy: StatsStrategy;
  } | null>(null);

  return (
    <>
      <div>
        <Select
          values={questionnaireTypes}
          value={type}
          onChange={(newValue) => {
            setType(newValue);
          }}
        />{" "}
        <Select
          values={statsStrategies}
          value={strategy}
          onChange={(newValue) => {
            setStrategy(newValue);
          }}
        />{" "}
        <Button
          onClick={() => {
            setShowStatsFor({ type, strategy });
          }}
        >
          <Trans>Load stats</Trans>
        </Button>
      </div>

      {showStatsFor && (
        <QuestionnaireStats
          type={showStatsFor.type}
          strategy={showStatsFor.strategy}
          api={props.api}
        />
      )}
    </>
  );
}
